"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const hiddenscroll_1 = __importDefault(require("@kawaui/hiddenscroll"));
const styles_1 = require("../styles");
const product_detail_recovery_1 = __importDefault(require("./product-detail-recovery"));
const ItemCarousel = ({ items, onToggle, i18n }) => ((0, jsx_runtime_1.jsx)(styles_1.MultipleItemsContainer, { children: (0, jsx_runtime_1.jsx)(hiddenscroll_1.default, { children: items.map((item) => item && item.product_id && (0, jsx_runtime_1.jsx)(product_detail_recovery_1.default, { item: item, onToggle: onToggle, i18n: i18n }, item.product_id)) }) }));
exports.default = ItemCarousel;
